query BasketballTeamByTeamId (
  $teamId: UUID!
){
  team: basketballTeamByTeamId(teamId: $teamId) {
    squad
    teamId
    playerMappedForProjections: basketballTeamPlayerProjectionsMappedsByTeamId {
      nodes {
        playerId
      }
    }
  }
}
